module.exports = __webpack_public_path__ + "static/media/david.d4d93cc4.png";